"use client";
import React from "react";

export const NoiseOverlay = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={`relative ${className || ""}`}>
      <Noise />
      {children}
    </div>
  );
};

const Noise = () => {
  return (
    <div
      className="absolute inset-0 w-full h-full opacity-10 [mask-image:radial-gradient(#fff,transparent,75%)]"
      style={{
        backgroundImage: "url(/noise.webp)",
        backgroundSize: "30%",
      }}
    />
  );
};
